module.exports = __webpack_public_path__ + "static/media/31.c48ffa36.gif";